// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// for the giant ignored paths table. you can't miss it.
// the table itself is going to be rendered through <DataTable />
// so redux-form doesn't have to worry about any sorting nonsense.
// uniqueId is required for <DataTable />.
// See components/DataTable/info.txt for details
// oh and, we're transforming like so bc it's the only place this scheme exists
// and we want to use this data with PathSummary components for the columns/cells

// NOTE - we default ignoredPaths to an empty array because when setting the
// default values for the AFS Result Filter, the API does not provide
// an ignoredPaths property and this operation would otherwise fail.

const scrubIgnoredPathsForForm = (ignoredPaths = []) => (
  ignoredPaths.map(d => {
    const {
      band,
      pathId,
      rcnNumber,
    } = d

    const site1 = {
      callSign: d.site1CallSign,
      contactCode: d.site1ContactCode,
      siteName: d.site1Name,
    }

    const site2 = {
      callSign: d.site2CallSign,
      contactCode: d.site2ContactCode,
      siteName: d.site2Name,
    }

    return {
      site1,
      site2,
      band,
      pathId,
      rcnNumber,
      uniqueId: 'pathId',
    }
  })
)

export default scrubIgnoredPathsForForm
